import React from "react";
import { Link } from "react-router-dom";

const NavButton = ({ to, btnName, className = "", selectState = false }) => {
  return (
    <Link
      to={to}
      aria-label={btnName}
      className={`inline-flex h-10 items-center justify-center rounded-xl px-5 text-sm font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-teal-400/40 active:scale-[0.97] ${
        selectState
          ? "bg-gradient-to-r from-teal-500 to-cyan-500 text-white shadow-md shadow-teal-500/30"
          : "bg-white/5 text-main-subfont border border-white/10 hover:border-teal-400/50 hover:text-brand-teal"
      } ${className}`}
    >
      <span>{btnName}</span>
    </Link>
  );
};

export default NavButton;
